/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import UpdateProfile from './UpdatePage'
import UpdateNewProfile from './updateNewProfile'


const UpdateWrapper: FC = () => {
 // const intl = useIntl()
  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.HOME'})}</PageTitle> */}
      {/* <UpdateProfile /> */}
      <UpdateNewProfile/>
    </>
  )
}

export default UpdateWrapper